import { render } from "./PrescriptionPrintLeftTopBlank.vue?vue&type=template&id=c5ebe300&scoped=true"
import script from "./PrescriptionPrintLeftTopBlank.vue?vue&type=script&lang=js"
export * from "./PrescriptionPrintLeftTopBlank.vue?vue&type=script&lang=js"

import "./PrescriptionPrintLeftTopBlank.vue?vue&type=style&index=0&id=c5ebe300&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ebe300"]])

export default __exports__